import { render } from "./RemarketingNew.vue?vue&type=template&id=d3180ed6&scoped=true"
import script from "./RemarketingNew.vue?vue&type=script&lang=js"
export * from "./RemarketingNew.vue?vue&type=script&lang=js"

import "./RemarketingNew.vue?vue&type=style&index=0&id=d3180ed6&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3180ed6"]])

export default __exports__